// extracted by mini-css-extract-plugin
export default {"emoji_sender_wrapper":"styles_emoji_sender_wrapper__WzTb6","emoji_input_icon":"styles_emoji_input_icon__pvDnR"};